import { defineMessages } from 'react-intl';

var messages = defineMessages({
  ariaLabel: {
    id: "neptune.ClearButton.ariaLabel"
  }
});

export { messages as default };
//# sourceMappingURL=DateTrigger.messages.mjs.map
